var plugin_default = {
  "alignLeft": "bpN4N",
  "textWrapNowrap": "stZN9",
  "alignRight": "tBV85",
  "alignCenter": "mz4ip",
  "sizeFullWidth": "GaTDd",
  "renderedInTable": "JIRvT",
  "sizeOriginal": "pS4Gt",
  "sizeContent": "cFjnM",
  "sizeSmall": "LKSJd",
  "sizeSmallCenter": "_8O3Fq",
  "flex": "xBxyp",
  "atomic": "_8tM-q",
  "embed": "N8vC7",
  "horizontalScrollbar": "_4Q4T7",
  "pluginContainerMobile": "LYVpm"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
